/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssetComplianceTypeID {
    HazMat = 1,
    FAST = 2,
    CSA = 3,
    TWIC = 4,
    COVIDVaccine1 = 5,
    COVIDVaccine2 = 6,
    COVIDVaccine3 = 7,
    DOTInspection = 8,
    MaintenanceCheck = 9,
    TSA = 10,
    CaliforniaCTC = 11,
    OregonPermit = 12,
    NewYorkPermit = 13,
    NewMexicoPermit = 14,
    KentuckyPermit = 15,
    CarrierAgreement = 16,
    NOA = 17,
    Pet = 18,
    HazMatTraining = 19,
    ApprovedPassenger = 20,
    DODApproved = 21,
    SecurityThreatAssessment = 22,
}
